import fetchJSON from '../../../js/utils/fetch/fetchJSON';
import settings from '../../../js/utils/settings';
import getHCStorage from '../../../js/sem/storage-manager/getHCStorage';
import getSnowplowIdCookie from '../../../js/utils/dom/cookies/getSnowPlowIdCookie';

const subDomain = settings.subDomainWithQA;

/**
 * @param {Function} callback if exits callback function the request is sync
 * @returns {Promise}
 */
function auditLead() {
  const store = getHCStorage();
  const auditUrl = `https://sem-content${subDomain}.healthcare.com/lead/audit`;
  const applicant = (store.members || []).find(
    member => member.type.toLowerCase() === 'primary',
  );

  const request = {
    url: auditUrl,
    data: {
      f_name: applicant.firstName || '',
      l_name: applicant.lastName || '',
      email: store.contact.email_address || '',
      phone1: store.contact.phone_home.replace(/\D/g, '') || '',
      address1: store.contact.address || '',
      city: store.location.city || '',
      state: store.location.state || '',
      zip: store.location.zip_code || '',
      tcpa_universal_id:
        window.LeadiD && window.LeadiD.token ? window.LeadiD.token : '',
      dob: applicant.dob || '',
      gender: applicant.gender || '',
    },
  };

  const spIdCookie = getSnowplowIdCookie();
  if (spIdCookie) {
    request.headers = {
      'Content-Type': 'application/json',
      'snowplow-data': spIdCookie,
    };
  }

  return fetchJSON(request);
}

export default auditLead;
